import { MenuOutlined } from '@ant-design/icons';
import { Table } from 'antd';
import { arrayMoveImmutable } from 'array-move';
import React from 'react';
import { SortableContainer, SortableElement, SortableHandle } from 'react-sortable-hoc';
const DragHandle = SortableHandle((props) => (
    <div className="flex flex-row items-center justify-center gap-3">

        <MenuOutlined
            style={{
                cursor: props.canSort ? 'grab' : 'default',
                color: '#999',
            }}
        />
        {props.children}
    </div>
));

const SortableItem = SortableElement((props) => <tr {...props} />);
const SortableBody = SortableContainer((props) => <tbody {...props} />);

/**
 * @param {string} [orderKey] Field holding the row's display order. Kept separate
 *   from `rowKey` so a table can be keyed on something guaranteed-unique (or a
 *   function) while still showing its ordering value in the drag column.
 */
const SortableTable = ({canSort = true, sortLabel = "Sort", orderKey = 'display_index', children, onSortChange = () => true, dataSource = [],...props}) => {

    // Resolve a row's key exactly the way antd does, so the `data-row-key`
    // lookup below matches whether `rowKey` is a string or a function.
    const getRowKey = (record, index) => (
        typeof props.rowKey === 'function'
            ? props.rowKey(record, index)
            : record[props.rowKey || orderKey]
    );

    const onSortEnd = ({ oldIndex, newIndex }) => {
        let source = [...dataSource];
        if (oldIndex !== newIndex) {
            const newData = arrayMoveImmutable(source.slice(), oldIndex, newIndex).filter(
                (el) => !!el,
            );
            console.log('Sorted items: ', newData);
            onSortChange(newData);
        }
    };
    const DraggableContainer = (dragProps) => (
        <SortableBody
            useDragHandle
            disableAutoscroll
            helperClass="row-dragging"
            onSortEnd={onSortEnd}
            {...dragProps}
        />
    );

    const DraggableBodyRow = ({ className, style, ...restProps }) => {
        // findIndex based on the table's rowKey, so this is always the right array
        // index. Compared as strings because antd stringifies `data-row-key`.
        const index = dataSource.findIndex(
            (x, i) => `${getRowKey(x, i)}` === `${restProps['data-row-key']}`
        );
        return <SortableItem index={index} {...restProps} className={className}/>;
    };

    return (
        <Table
            {...props}
            dataSource={dataSource}
            components={canSort ? {
                body: {
                    wrapper: DraggableContainer,
                    row: DraggableBodyRow,
                },
            } : undefined}
        >

                <Table.Column
                    title={sortLabel}
                    dataIndex="sort"
                    width={30}
                    className={canSort ? "drag-visible" : undefined}
                    render={(_, member, index) => (
                        <DragHandle canSort={canSort}>
                            <p className="text-base font-semibold">
                                {/* `display_index` is 0-based on the server, so show the
                                    row's 1-based position instead — nobody wants to be
                                    told they're number 0. Derived from the row index
                                    rather than the stored value so the column always
                                    reads 1..n even if the underlying indexes have gaps. */}
                                {index + 1}
                            </p>
                        </DragHandle>
                    )}/>

                {children}
        </Table>
    )
};

export default SortableTable;